import { createRouter, createWebHistory } from "vue-router";
import i18n from "@/i18n";

// Layouts
import BasicLayout from "@/layouts/app/BasicLayout.vue";
import ExperienceLayout from "@/layouts/experience/ExperienceLayout.vue";
// Views
// |_ Not authenticated
import AuthView from "@/views/auth/AuthView.vue"
import Maintenance from "@/views/app/errors/Maintenance.vue";
import AssessmentListView from "@/views/experience/AssessmentListView.vue";
import AssessmentDetailView from "@/views/experience/AssessmentDetailView.vue";

import ErrorLayout from "@/layouts/app/Error.vue";
// Navigation guards
import { authGuard } from "@/guards/auth.guard";
import { maintenanceGuard } from "@/guards/maintenance.guard";
import { urlTokenGuard } from "@/guards/url-token.guard";

const { t } = i18n.global;

const experienceRouter = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/auth",
      name: "auth",
      component: AuthView,
      meta: {
        layout: BasicLayout,
        isPublic: true,
        isTransverse: true,
        document_title: t("app.router.login.documentTitle"),
      },
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: Maintenance,
      meta: {
        isPublic: true,
        layout: ErrorLayout,
      },
    },
    // Authenticated
    {
      path: "/",
      name: "home",
      redirect: { name: "invitations" },
    },
    {
      path: "/invitations",
      name: "invitations",
      component: AssessmentListView,
      props: { status: "invited" },
    },
    {
      path: "/in-progress",
      name: "in-progress",
      component: AssessmentListView,
      props: { status: "started" },
    },
    {
      path: "/finished",
      name: "finished",
      component: AssessmentListView,
      props: { status: "finished" },
    },
    {
      path: "/assessments/:participantId",
      name: "assessment",
      component: AssessmentDetailView,
      props: true,
    },
  ],
});

const guards = [urlTokenGuard, maintenanceGuard, authGuard];

experienceRouter.beforeEach(async (to, from) => {
  document.title = to.meta.title ? `${to.meta.title}` : 'Experience Yuzu';
  // Run guards
  for (const guard of guards) {
    const result = await guard(to, from)
    if (result) return result;
  }
});

export default experienceRouter;
